export default __webpack_public_path__ + "static/media/i107hp.be042964.webp";